import { useRef } from 'react'
import clamp from 'lodash-es/clamp'

import {
  bindDrag,
  getSvPointerPosition,
  getSvSquareBackground,
} from '../ColorPickerPopover.utils'

import * as styles from './ColorPickerPopoverSvSquare.module.css'

function ColorPickerPopoverSvSquare({ color, hsv, onChange }) {
  const squareRef = useRef(null)

  function updateSaturationValue(clientX, clientY) {
    if (!squareRef.current) {
      return
    }

    const rect = squareRef.current.getBoundingClientRect()
    const x = clamp(clientX - rect.left, 0, rect.width)
    const y = clamp(clientY - rect.top, 0, rect.height)

    onChange({
      s: x / rect.width,
      v: 1 - y / rect.height,
    })
  }

  function handleMouseDown(event) {
    updateSaturationValue(event.clientX, event.clientY)

    bindDrag(moveEvent => {
      updateSaturationValue(moveEvent.clientX, moveEvent.clientY)
    })
  }

  return (
    <div
      className={styles.ColorPickerPopoverSvSquare}
      ref={squareRef}
      style={{ backgroundColor: getSvSquareBackground(hsv.h) }}
      onMouseDown={handleMouseDown}
    >
      <div className={styles.whiteLayer} />
      <div className={styles.blackLayer} />
      <div
        className={styles.pointer}
        style={{
          ...getSvPointerPosition(hsv),
          backgroundColor: color,
        }}
      />
    </div>
  )
}

export default ColorPickerPopoverSvSquare
